import React from 'react';
import Icon from '../../../components/AppIcon';

const StatisticsCard = ({ title, value, change, icon, trend }) => {
  const isPositive = trend === 'up';
  
  return (
    <div className="bg-card border border-border rounded-lg p-4 md:p-6 hover:shadow-lg transition-all duration-250">
      <div className="flex items-start justify-between mb-4">
        <div className="w-10 h-10 md:w-12 md:h-12 rounded-lg bg-primary/10 flex items-center justify-center">
          <Icon name={icon} size={20} className="text-primary" />
        </div>
        {change && (
          <div className={`flex items-center gap-1 px-2 py-1 rounded-lg text-xs font-medium ${
            isPositive ? 'bg-success/10 text-success' : 'bg-error/10 text-error'
          }`}>
            <Icon name={isPositive ? 'TrendingUp' : 'TrendingDown'} size={14} />
            <span>{change}</span>
          </div>
        )}
      </div>
      
      <div>
        <p className="text-2xl md:text-3xl font-semibold text-foreground mb-1">
          {value}
        </p>
        <p className="text-xs md:text-sm text-muted-foreground">
          {title}
        </p>
      </div>
    </div>
  );
};

export default StatisticsCard;